import { render, staticRenderFns } from "./SubscriptionPlansCollapsed.vue?vue&type=template&id=1cddd8a7&scoped=true"
import script from "./SubscriptionPlansCollapsed.vue?vue&type=script&lang=js"
export * from "./SubscriptionPlansCollapsed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cddd8a7",
  null
  
)

export default component.exports